// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { TrustDetailsSubformTrusteeFragment } from '../../../TrustDetailsSubform/graphql/TrustDetails.generated';
import { TrustAdvisorsList_TrustAdvisorFragment } from '../../../../trusts/TrustAdvisorsList/graphql/TrustAdvisorsList.fragments.generated';
import { BeneficiarySubform_BeneficiaryFragment } from '../../../EntityBeneficiariesSubform/graphql/Beneficiaries.generated';
import { gql } from '@apollo/client';
import { TrustDetailsSubformTrusteeFragmentDoc } from '../../../TrustDetailsSubform/graphql/TrustDetails.generated';
import { TrustAdvisorsList_TrustAdvisorFragmentDoc } from '../../../../trusts/TrustAdvisorsList/graphql/TrustAdvisorsList.fragments.generated';
import { BeneficiarySubform_BeneficiaryFragmentDoc } from '../../../EntityBeneficiariesSubform/graphql/Beneficiaries.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditTestamentaryEntity_ControllingPartyFragment = { __typename?: 'ControllingParty', id: string, individual?: { __typename?: 'ClientProfile', id: string, legalName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null };

export type GetTestamentaryEntityForEditQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.TestamentaryEntityWhereInput>;
}>;


export type GetTestamentaryEntityForEditQuery = { __typename?: 'Query', testamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: { __typename?: 'TestamentaryEntity', id: string, displayName: string, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null, inEstateStatus?: Types.EntityInEstateStatus | null, survivingSpouseStateInEstateStatus?: Types.EntityInEstateStatus | null, kind: Types.TestamentaryEntityKind, taxStatus?: Types.NonTrustEntityTaxStatus | null, description?: string | null, householdID: string, successorTrustees?: Array<(
          { __typename?: 'Trustee' }
          & TrustDetailsSubformTrusteeFragment
        )> | null, trustees?: Array<(
          { __typename?: 'Trustee' }
          & TrustDetailsSubformTrusteeFragment
        )> | null, trustAdvisors?: Array<(
          { __typename?: 'TrustAdvisor' }
          & TrustAdvisorsList_TrustAdvisorFragment
        )> | null, controllingParties?: Array<(
          { __typename?: 'ControllingParty' }
          & EditTestamentaryEntity_ControllingPartyFragment
        )> | null, beneficiaries?: Array<(
          { __typename?: 'Beneficiary' }
          & BeneficiarySubform_BeneficiaryFragment
        )> | null, beneficiariesAfterBothGrantorDeaths?: Array<(
          { __typename?: 'Beneficiary' }
          & BeneficiarySubform_BeneficiaryFragment
        )> | null, accountOwner?: { __typename?: 'ClientProfile', id: string } | null, createdFromEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } } | null } | null> | null } };

export const Operations = {
  Query: {
    GetTestamentaryEntityForEdit: 'GetTestamentaryEntityForEdit' as const
  },
  Fragment: {
    EditTestamentaryEntity_ControllingParty: 'EditTestamentaryEntity_ControllingParty' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EditTestamentaryEntity_ControllingPartyFragmentDoc = gql`
    fragment EditTestamentaryEntity_ControllingParty on ControllingParty {
  id
  individual {
    id
    legalName
  }
  organization {
    id
    name
  }
}
    `;
export const GetTestamentaryEntityForEditDocument = gql`
    query GetTestamentaryEntityForEdit($where: TestamentaryEntityWhereInput) {
  testamentaryEntities(where: $where) {
    edges {
      node {
        id
        displayName
        gstStatus
        inclusionRatio
        inEstateStatus
        survivingSpouseStateInEstateStatus
        kind
        taxStatus
        description
        householdID
        successorTrustees {
          ...TrustDetailsSubformTrustee
        }
        trustees {
          ...TrustDetailsSubformTrustee
        }
        trustAdvisors {
          ...TrustAdvisorsList_TrustAdvisor
        }
        controllingParties {
          ...EditTestamentaryEntity_ControllingParty
        }
        beneficiaries {
          ...BeneficiarySubform_Beneficiary
        }
        beneficiariesAfterBothGrantorDeaths {
          ...BeneficiarySubform_Beneficiary
        }
        accountOwner {
          id
        }
        createdFromEntities {
          edges {
            node {
              id
              subtype {
                id
                displayName
              }
            }
          }
        }
      }
    }
  }
}
    ${TrustDetailsSubformTrusteeFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${EditTestamentaryEntity_ControllingPartyFragmentDoc}
${BeneficiarySubform_BeneficiaryFragmentDoc}`;

/**
 * __useGetTestamentaryEntityForEditQuery__
 *
 * To run a query within a React component, call `useGetTestamentaryEntityForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestamentaryEntityForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestamentaryEntityForEditQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTestamentaryEntityForEditQuery(baseOptions?: Apollo.QueryHookOptions<GetTestamentaryEntityForEditQuery, GetTestamentaryEntityForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestamentaryEntityForEditQuery, GetTestamentaryEntityForEditQueryVariables>(GetTestamentaryEntityForEditDocument, withFetchPolicyContext(options));
      }
export function useGetTestamentaryEntityForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestamentaryEntityForEditQuery, GetTestamentaryEntityForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestamentaryEntityForEditQuery, GetTestamentaryEntityForEditQueryVariables>(GetTestamentaryEntityForEditDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetTestamentaryEntityForEditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestamentaryEntityForEditQuery, GetTestamentaryEntityForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestamentaryEntityForEditQuery, GetTestamentaryEntityForEditQueryVariables>(GetTestamentaryEntityForEditDocument, withFetchPolicyContext(options));
        }
export type GetTestamentaryEntityForEditQueryHookResult = ReturnType<typeof useGetTestamentaryEntityForEditQuery>;
export type GetTestamentaryEntityForEditLazyQueryHookResult = ReturnType<typeof useGetTestamentaryEntityForEditLazyQuery>;
export type GetTestamentaryEntityForEditSuspenseQueryHookResult = ReturnType<typeof useGetTestamentaryEntityForEditSuspenseQuery>;
export type GetTestamentaryEntityForEditQueryResult = Apollo.QueryResult<GetTestamentaryEntityForEditQuery, GetTestamentaryEntityForEditQueryVariables>;